var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "admin-base-layout",
    [
      _c("template", { slot: "admin-page-header" }, [
        _c("div", { staticClass: "flex-wrap-spacing" }, [
          _c("h3", { staticClass: "page-header" }, [_vm._v("Tokens")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex-wrap-spacing tokens-actions" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary tests_add_token_action",
              on: {
                click: function($event) {
                  return _vm.goToAddToken()
                }
              }
            },
            [
              _c("i", { staticClass: "fa fa-plus fa-fw" }),
              _vm._v("Generate New Token")
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "template",
        { slot: "admin-page-content" },
        [
          !_vm.tokens ? _c("loader") : _vm._e(),
          _vm._v(" "),
          _vm.tokens && _vm.tokens.length == 0
            ? _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-xs-12" }, [
                  _vm._v("\n\t\t\t\tNo tokens yet.\n\t\t\t")
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.tokens && _vm.tokens.length > 0
            ? _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-xs-12 pad0" }, [
                  _c("div", { staticClass: "table-responsive" }, [
                    _c(
                      "table",
                      { staticClass: "table table-hover tests_tokens_table" },
                      [
                        _c("thead", [
                          _c("tr", [
                            _c("th", [_vm._v("ID")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Namespace")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Created")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Expires")]),
                            _vm._v(" "),
                            _c("th")
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(_vm.tokens, function(token) {
                            return _c("tr", { key: token.name }, [
                              _c("td", { staticClass: "tests_token_id" }, [
                                _vm._v(_vm._s(token.id))
                              ]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(token.namespace))]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("moment")(
                                      token.createdAt,
                                      "from",
                                      "now"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("moment")(
                                      token.expires,
                                      "from",
                                      "now"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "table-item-actions" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "tests_delete_token_action",
                                    attrs: { title: "invalidate token" },
                                    on: {
                                      click: function($event) {
                                        return _vm.deleteToken(token.id)
                                      }
                                    }
                                  },
                                  [_c("i", { staticClass: "fa fa-times" })]
                                )
                              ])
                            ])
                          }),
                          0
                        )
                      ]
                    )
                  ])
                ])
              ])
            : _vm._e()
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-19d2626c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19d2626c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tokens.vue
// module id = null
// module chunks = 